import { useState } from "react";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ForgotPasswordModal from "./ForgotPasswordModal";
import "./Auth.css";

function LoginPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const from = location.state?.from?.pathname || "/";

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (isLoading) return;
    setIsLoading(true);
    setErrorMessage("");

    const formData = new FormData(event.currentTarget);
    const email = formData.get("email") as string;
    const password = formData.get("password") as string;

    auth.login(email, password, (success, em?) => {
      if (success) {
        navigate(from, { replace: true });
      } else if (typeof em !== "undefined") {
        setErrorMessage(em);
      }
      setIsLoading(false);
    });
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <div className="auth-logo">
              <i className="bi bi-bar-chart-steps" />
            </div>
            <h1 className="auth-title">Welcome back</h1>
            <p className="auth-subtitle">Sign in to your account to continue</p>
          </div>

          <Form className="auth-form" onSubmit={handleSubmit}>
            {errorMessage && (
              <Alert variant="danger" className="auth-alert">
                {errorMessage}
              </Alert>
            )}

            <Form.Group className="mb-3">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                name="email"
                type="email"
                placeholder="you@example.com"
                required
                autoComplete="email"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                name="password"
                type="password"
                placeholder="Enter your password"
                required
                autoComplete="current-password"
              />
            </Form.Group>

            <button
              type="button"
              className="auth-forgot-link"
              onClick={() => {
                setShowForgotPassword(true);
              }}
            >
              Forgot password?
            </button>

            <Button
              variant="primary"
              type="submit"
              className="auth-submit-btn"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Signing in...
                </>
              ) : (
                "Sign in"
              )}
            </Button>
          </Form>

          <div className="auth-footer">
            <p className="auth-footer-text">
              Don&rsquo;t have an account?{" "}
              <Link to="/register" className="auth-footer-link">
                Create account
              </Link>
            </p>
          </div>
        </div>
      </div>

      <ForgotPasswordModal
        show={showForgotPassword}
        onHide={() => setShowForgotPassword(false)}
      />
    </div>
  );
}

export default LoginPage;
